const defaultFetchSetting = {
    method: 'GET',
    body: undefined,
    signal: undefined,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

function prepareFetchSettings(settings) {
    return {
        credentials: 'include',
        method: settings.method.toUpperCase(),
        body: settings.body,
        headers: new Headers(settings.headers),
        signal: settings.signal,
    }
}

function setValue(key: string, value: string) {
    console.log('ARES: [data-ares="'+key+'"]');
    let input = document.querySelector('[data-ares="'+key+'"]');
    if(input !== null) {
        console.log(input);
        console.log(value);
        input.value = value;
    }
}

export function run() {
    console.log('ARES: Run');
    let element = document.querySelector('[data-ares-url]');

    if(element !== null) {
        console.log('ARES: Found element');

        element.addEventListener('input', function() {
            if(element.value.length === 8) {
                console.log('ARES: Start search');
                let spinnerArea = document.querySelector('[data-ares-spinner]');

                if(spinnerArea !== null) {
                    spinnerArea.style.display = 'block';
                }

                let url = element.getAttribute('data-ares-url') + element.value;
                console.log('ARES: url ' + url);
                const settings = Object.assign({}, defaultFetchSetting, {});

                fetch(
                    url, prepareFetchSettings(settings)
                ).then(function(response) {
                    console.log('ARES: Response');
                    return response.json();
                }).then(response => {
                    if(response.hasOwnProperty('ico')) {
                        setValue('ico', response.ico);
                        setValue('dic', response.dic);
                        setValue('name', response.name);
                        setValue('street', response.street);
                        setValue('city', response.city);
                        setValue('zipCode', response.zipCode);
                    } else {
                        setValue('dic', '');
                        setValue('name', '');
                        setValue('street', '');
                        setValue('city', '');
                        setValue('zipCode', '');
                    }

                    if(spinnerArea !== null) {
                        spinnerArea.style.display = 'none';
                    }
                });
            }
        });
    }
}
